module.exports = __webpack_public_path__ + "img/ramp-up_a.132fd336.png";